<div class="side-menu" [ngClass]="{'collapsed': isCollapsed}">
    <button
      pButton
      [icon]="isCollapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"
      class="p-button-text toggle-btn"
      (click)="toggleCollapse()"
      [pTooltip]="isCollapsed ? 'Expand menu' : 'Collapse menu'"
      tooltipPosition="right">
    </button>

    <div class="logo-section">
      <h1 class="logo-text">{{ isCollapsed ? 'A' : 'Admore' }}</h1>
      <div class="logo-underline"></div>
    </div>

    <p-menu [model]="menuItems" styleClass="custom-menu"></p-menu>
  </div>
  